import { AuthService } from 'phoenix/services';
import { LoginIdpCallbackDirective } from './login-idp-callback.component';
import { LoginDirective } from './login.component';
import { LoginMainDirective } from './login-main.component';
import { LoginResetPasswordDirective } from './login-reset-password.component';
import { LoginRegisterDirective } from './login-register.component';
import { RegisterUserDirective } from './login-register-user.component';
import { 
	loginParentRoute, 
	routes 
} from './login.routes';
require('./login.styles');
export const loginModule = angular
	.module('phoenix.login', [
		'ngMaterial', 
		'util.common',
		'phoenix.services', 
		'phoenix.interceptors'
	])
	.run([
		'pxAuthService', 
		'$state', 
		'$rootScope', 
		'$window', 
		(pxAuthService: AuthService, $state, $rootScope:ng.IRootScopeService, $window:ng.IWindowService) => {
			(function checkForOauth(){
				let idpCallbackRegex = /id_token=/i;
				let cancelledLoginRegex = /error_description=cancelled/i;

			if($window.location && $window.location.hash){
				let hash = $window.location.hash;
				let queryParams = hash
					.replace('#/','')
					.split('&')
					.reduce((kvPairs, pair) => {
						let tuple = pair.split('=');
						kvPairs[tuple[0]] = tuple[1];
						return kvPairs;
					}, {});

				if(hash.match(idpCallbackRegex)){
					$state.go('idpCallback', queryParams);
				}
				else if(hash.match(cancelledLoginRegex)){
					pxAuthService.rememberedEmail = null;
					pxAuthService.invalidateLogin();
				}				
			}
		})();
	}])
	.config([
		'$stateProvider', 
		'$injector',
		($stateProvider:ng.ui.IStateProvider) => {
			routes.forEach(r => $stateProvider.state(r));
		}
	])
	.directive('pxLogin', LoginDirective)
	.directive('pxLoginMain', LoginMainDirective)
	.directive('pxLoginRegister', LoginRegisterDirective)
	.directive('pxLoginRegisterUser', RegisterUserDirective)
	.directive('pxLoginResetPassword', LoginResetPasswordDirective)
	.directive('pxLoginIdpCallback', LoginIdpCallbackDirective);


// WEBPACK FOOTER //
// ./src/phoenix/components/login/index.ts